import { AppSidebar } from "@/components/app-layout/AppSidebar";
import { SidebarContentAdmin } from "@/components/app-layout/menus/SidebarContentSettings";
import {
  EXPERT_ICON,
  TEMPLATE_ICON,
} from "@/components/display/display-icon/artifacts.tsx";
import { useGroupData } from "@/data/use-groups-data";
import {
  faCircleInfo,
  faFlag,
  faMessageCode,
  faShapes,
  faUsers,
} from "@nnr/fontawesome-sharp-light/icons/sharp/light";
import { Outlet, useParams } from "@tanstack/react-router";

export const GlobalAdminGroupLayout = () => {
  const { groupUuid } = useParams({ strict: false }) as {
    groupUuid: string;
  };
  const group = useGroupData(groupUuid).group;

  if (!group) return null;

  return (
    <>
      <AppSidebar.ContentPortal>
        <SidebarContentAdmin
          title={`Group: ${group.name}`}
          settings={[
            {
              name: "Details",
              link: {
                to: "/admin/groups/$groupUuid/details",
                params: { groupUuid },
              },
              icon: faCircleInfo,
            },
            {
              name: "Feature Flags",
              link: {
                to: "/admin/groups/$groupUuid/feature-flags",
                params: { groupUuid },
              },
              icon: faFlag,
            },
            {
              name: "Users",
              link: {
                to: "/admin/groups/$groupUuid/users",
                params: { groupUuid },
              },
              icon: faUsers,
            },
            {
              name: "Experts",
              link: {
                to: "/admin/groups/$groupUuid/experts",
                params: { groupUuid },
              },
              icon: EXPERT_ICON,
            },
            {
              name: "Presets",
              link: {
                to: "/admin/groups/$groupUuid/presets",
                params: { groupUuid },
              },
              icon: faShapes,
            },
            {
              name: "Templates",
              link: {
                to: "/admin/groups/$groupUuid/templates",
                params: { groupUuid },
              },
              icon: TEMPLATE_ICON,
            },
            {
              name: "Custom Prompts",
              link: {
                to: "/admin/groups/$groupUuid/custom-prompts",
                params: { groupUuid },
              },
              icon: faMessageCode,
            },
          ]}
        />
      </AppSidebar.ContentPortal>
      <Outlet />
    </>
  );
};
